import { PAYMENT_METHODS } from '@app/transaction';
import {
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_PAYMENT_METHODS_FAILURE,
} from './actions';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  localMethods: [],
};

export function paymentMethods(
  state = INITIAL_STATE,
  { type, payload = {} }: any = {},
) {
  switch (type) {
    case FETCH_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        localMethods: payload.localMethods.map((method) => ({
          ...method,
          ...PAYMENT_METHODS[method.name],
        })),
      };
    case FETCH_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error,
        localMethods: null,
      };
    default:
      return state;
  }
}
